export default {
  admission: "admission",
  unitAdmission: "Unit Admission",
  todayReceptions: "Today's Receptions",
  homePage: "Home Page",
  usersList: "Users List",
  doctorsList: "Doctors List",
  patientsList: "Patients List",
  addUser: "Add User",
  addPatient: "Add Patient",
  editUser: "Edit User",
  editPatient: "Edit Patient",
  addUserService: "Add Service",
  addReferral: "Add Referral",
  services: "Services",
  addServices: "add Services",
  editServices: "edit Services",
  service: "Service",
  section: "Sections",
  addSection: "Add Sections",
  editSection: "Edit Sections",
  unit: "Units",
  addUnit: "add Units",
  editUnit: "edit Units",
  room: "Rooms",
  addRoom: "Add Room",
  editRoom: "Edit Room",
  patientReceptionQueue: "Patient Reception Queue",
  bed: "Beds",
  addBed: "add Bed",
  editBed: "edit Bed",
  sectionsReception: "Sections Reception",
  receptionUnits: "Units",
  receptionsInRoom: "Rooms",
  discountGroups: "Discount Groups",
  addDiscountGroups: "add Discount Groups",
  editDiscountGroups: "edit Discount Groups",
  setting: "Setting",
  currency: "Currency",
  addCurrency: "add Currency",
  editCurrency: "edit Currency",
  medicalRecords: "Medical Records",
  baseInformation: "Base Information",
  userRelated: "User Related",
  structure: "structure",
  familyRelationships: "Family Relationships",
  addFamilyRelationships: "add Family Relationships",
  editFamilyRelationships: "edit Family Relationships",
  bloodTypes: "Blood Types",
  addBloodTypes: "add Blood Types",
  editBloodTypes: "edit Blood Types",
  cyclePains: "Cycle Pains",
  addCyclePains: "add Cycle Pains",
  editCyclePains: "edit Cycle Pains",
  contraceptives: "Contraceptives",
  addContraceptives: "add Contraceptives",
  editContraceptives: "edit Contraceptives",
  diseases: "Diseases",
  addDiseases: "add Diseases",
  editDiseases: "edit Diseases",
  cancers: "Cancers",
  addCancers: "add Cancers",
  editCancers: "edit Cancers",
  surgeryCategories: "Surgery Categories",
  surgeries: " Surgeries",
  sonographies: " Sonographies",
  radiologyTests: " Radiology Tests",
  addRadiologyTests: "add Radiology Tests",
  editRadiologyTests: "edit Radiology Tests",
  medications: " Medications",
  addMedications: "add Medications",
  editMedications: "edit Medications",
  pregnancyMethods: " Pregnancy Methods",
  addPregnancyMethods: "add Pregnancy Methods",
  editPregnancyMethods: "edit Pregnancy Methods",
  parityTypes: " parity",
  addParityTypes: "add parity",
  editParityTypes: "edit parity",
  abortionTypes: "Abortion Types",
  addAbortionTypes: "new Abortion Types",
  editAbortionTypes: "edit Abortion Types",
  abortionCauses: "Abortion Causes",
  addAbortionCauses: "add Abortion Causes",
  editAbortionCauses: "edit Abortion Causes",
  abortionMethods: "Abortion Methods",
  addAbortionMethods: "add Abortion Methods",
  editAbortionMethods: "edit Abortion Methods",
  ivfMethods: "ivf Methods",
  addIvfMethods: "add ivf Methods",
  editIvfMethods: "edit ivf Methods",
  transferOperationTypes: "transfer Operation Types",
  addTransferOperationTypes: "add transfer Operation Types",
  editTransferOperationTypes: "edit transfer Operation Types",
  ioMethods: "io Methods",
  addIoMethods: "add io Methods",
  editIoMethods: "edit io Methods",
  allergies: "Allergies",
  addAllergies: "new Allergies",
  editAllergies: "edit Allergies",
  addictions: "Addictions",
  addAddictions: "new Addictions",
  editAddictions: "edit Addictions",
  financialSettings: "Financial Settings",
  sectionsManagement: "Sections Management",
  accounting: "Accounting",
  unitAccounting: "Accounting",
  accountsHeadings: "Accounts Headings",
  accountGroups: "Accounts Groups",
  addAccountGroups: "add Accounts Groups",
  editAccountGroups: "edit Accounts Groups",
  totalAccounts: "Accounts Total",
  addTotalAccounts: "Accounts Total",
  editTotalAccounts: "Accounts Total",
  subsidiaryAccounts: "Subsidiary Account",
  addSubsidiaryAccounts: "add Subsidiary Account",
  editSubsidiaryAccounts: "edit Subsidiary Account",
  detailAccount: "Detail Account",
  addDetailAccount: "add Detail Account",
  editDetailAccount: "edit Detail Account",
  artificialReproductiveTechnologies: "artificial Reproductive Technologies",
  addArtificialReproductiveTechnologies:
    "new artificial Reproductive Technologies",
  editArtificialReproductiveTechnologies:
    "edit artificial Reproductive Technologies",
  urologyTests: "urologyTests",
  addUrologyTests: "add urologyTests",
  editUrologyTests: "edit urologyTests",
  pos: "Card Readers ",
  addPos: "add Card Readers ",
  editPos: "edit Card Readers ",
  financialDocuments: " Financial Documents ",
  accountingDocuments: " Accounting Documents ",
  indications: "Indications",
  addIndications: "add Indications",
  editIndications: "edit Indications",
  MedicalAbbreviationTests: "Abbreviation Tests",
  addMedicalAbbreviationTests: "add Abbreviation Tests",
  editMedicalAbbreviationTests: "edit Abbreviation Tests",
  examinationMethods: "Examination Methods",
  addExaminationMethods: "add Examination Methods",
  editExaminationMethods: "edit Examination Methods",
  examinationViews: "Examination Views",
  addExaminationViews: "add Examination Views",
  editExaminationViews: "edit Examination Views",
  cardiacActivities: "Cardiac Activities",
  addCardiacActivities: "add Cardiac Activities",
  editCardiacActivities: "edit Cardiac Activities",
  placentaLocations: "Placenta Locations",
  addPlacentaLocations: "add Placenta Locations",
  editPlacentaLocations: "edit Placenta Locations",
  impressionLocations: "Impression Locations",
  addImpressionLocations: "add Impression Locations",
  editImpressionLocations: "edit Impression Locations",
  bladderNodules: "Bladder Nodules",
  addBladderNodules: "add Bladder Nodules",
  editBladderNodules: "edit Bladder Nodules",
  uterusPositions: "Uterus Positions",
  addUterusPositions: "add Uterus Positions",
  editUterusPositions: "edit Uterus Positions",
  uterusSizes: "Uterus Sizes",
  addUterusSizes: "add Uterus Sizes",
  editUterusSizes: "edit Uterus Sizes",
  uterusAdenomyosisTests: "Adenomyosis Tests",
  addUterusAdenomyosisTests: "add Adenomyosis Tests",
  editUterusAdenomyosisTests: "edit Adenomyosis Tests",
  endometriumTests: "Endometrium Tests",
  addEndometriumTests: "Add Endometrium Tests",
  editEndometriumTests: "Edit Endometrium Tests",
  endometriumTypes: "Endometrium Types",
  addEndometriumTypes: "Add Endometrium Types",
  editEndometriumTypes: "Edit Endometrium Types",
  endometriumIsoTests: "Endometrium Iso Tests",
  addEndometriumIsoTests: "add Endometrium Iso Tests",
  editEndometriumIsoTests: "edit Endometrium Iso Tests",
  fibroidTypes: "Fibroid Types",
  addFibroidTypes: "add Fibroid Types",
  editFibroidTypes: "edit Fibroid Types",
  polypTypes: "Polyp Types",
  addPolypTypes: "add Polyp Types",
  editPolypTypes: "edit Polyp Types",
  threeDCoronals: "ThreeD Coronals",
  addThreeDCoronals: "add ThreeD Coronals",
  editThreeDCoronals: "edit ThreeD Coronals",
  endometriomaTypes: "Endometrioma Types",
  addEndometriomaTypes: "add Endometrioma Types",
  editEndometriomaTypes: "edit Endometrioma Types",
  ovarianAdhesionTypes: "OvarianAdhesionTypes",
  addOvarianAdhesionTypes: "add OvarianAdhesionTypes",
  editOvarianAdhesionTypes: "edit OvarianAdhesionTypes",
  dopplerStudyTypes: "Doppler Study Types",
  addDopplerStudyTypes: "add Doppler Study Types",
  editDopplerStudyTypes: "edit Doppler Study Types",
  pouchDouglasTypes: "Pouch Douglas Types",
  addPouchDouglasTypes: "add Pouch Douglas Types",
  editPouchDouglasTypes: "edit Pouch Douglas Types",
  uteroSacralLigamentNoduleTypes: "Utero Sacral Ligament",
  addUteroSacralLigamentNoduleTypes: "add Utero Sacral Ligament",
  editUteroSacralLigamentNoduleTypes: "edit Utero Sacral Ligament",
  rectoSigmoidNoduleTypes: "Recto Sigmoid Nodule Types ",
  addRectoSigmoidNoduleTypes: "add Recto Sigmoid Types ",
  editRectoSigmoidNoduleTypes: "edit Recto Sigmoid Types ",
  tendernessWithTheProbeTypes: "Tenderness Probe",
  addTendernessWithTheProbeTypes: "add Tenderness Probe",
  editTendernessWithTheProbeTypes: "edit Tenderness Probe",
  commentTypes: "Comment Types",
  addCommentTypes: "add Comment Types",
  editCommentTypes: "edit Comment Types",
  adnexaTypes: "Adnexa Types",
  addAdnexaTypes: "Adnexa Types",
  editAdnexaTypes: "Adnexa Types",
  gestationalSacTypes: "Gestational Sac Types",
  addGestationalSacTypes: "add Gestational Sac Types",
  editGestationalSacTypes: "edit Gestational Sac Types",
  gestationalLocationTypes: "Gestational Location",
  addGestationalLocationTypes: "add Gestational Location",
  editGestationalLocationTypes: "edit Gestational Location",
  yolkSacTypes: "Yolk Sac Types",
  addYolkSacTypes: "add Yolk Sac Types",
  editYolkSacTypes: "edit Yolk Sac Types",
  embryoSonographicTypes: "Embryo Sonographic",
  addEmbryoSonographicTypes: "add Embryo Sonographic",
  editEmbryoSonographicTypes: "edit Embryo Sonographic",
  bothOvariesTypes: "Both Ovaries Types",
  addBothOvariesTypes: "add Both Ovaries Types",
  editBothOvariesTypes: "edit Both Ovaries Types",
  planAndFollowUpTypes: "Plan And FollowUpTypes",
  addPlanAndFollowUpTypes: "add Plan FollowUpTypes",
  editPlanAndFollowUpTypes: "edit Plan FollowUpTypes",
  freeFluidTypes: "Free Fluid Types",
  addFreeFluidTypes: "add Free Fluid Types",
  editFreeFluidTypes: "edit Free Fluid Types",
  threeDCoronalViews: "ThreeD Coronal Views",
  addThreeDCoronalViews: "add ThreeD Coronal Views",
  editThreeDCoronalViews: "edit ThreeD Coronal Views",
  reports: "reports",
  doctorReport: "Doctor Report",
  cashierReport: "Cashier Report",
  sonographyForms: "Sonography",
  bankCards: "Bank Cards",
  addBankCards: "add Bank Cards",
  editBankCards: "edit Bank Cards",
  medicalSpecialties: "Medical Specialties",
  permission: "Permission",
  permissions: "Permissions",
  permissionGroups: "Permission Groups",
  medicalScientificDegrees: "Medical Scientific Degrees",
  addMedicalScientificDegrees: "add Medical Scientific Degrees",
  editMedicalScientificDegrees: "edit Medical Scientific Degrees",
  banks: "Banks",
  addBanks: "add Banks",
  editBanks: "edit Banks",
  gynecology: "Gynecology",
  obstetric: "Obstetric",
  serviceGroups: "service Groups",
  addServiceGroups: "add service Groups",
  editServiceGroups: "edit service Groups",
  monitoring: "Monitoring",
  patientsMonitoring: "Patients Monitoring",
  doctorsMonitoring: "Doctors Monitoring",
  countryDivisions: "country Divisions",
  countries: "countries",
  addCountries: "add countries",
  editCountries: "edit countries",
  provinces: "provinces",
  addProvinces: "add provinces",
  editProvinces: "edit provinces",
  cities: "cities",
  addCities: "add cities",
  editCities: "edit cities",
  serviceCategories: "service Categories",
  addServiceCategories: "add Service Categories",
  editServiceCategories: "edit Service Categories",
  centralCashier: "central cashier",
  reasonOfReferences: "reason Of References",
  addReasonOfReferences: "New Reason Of References",
  editReasonOfReferences: "edit Reason Of References",
  socialNetworks: "social Networks",
  addSocialNetworks: "New Social Networks",
  editSocialNetworks: "Edit Social Networks",
  permissionRooms: "permissionRooms",
  addPermissionRooms: "New Permission Rooms",
  editPermissionRooms: "Edit Permission Rooms",
  permissionUnits: "permission Units",
  addPermissionUnits: "add Permission Units",
  editPermissionUnits: "edit Permission Units",
  unitReport: "Unit Report",
  changePassword: "Change Password",
  message: "Message",
  settings: "Settings",
  calendar:"Calendar",
  editMessage:"Edit Message",
  addMessage:"Add Message",
  AppointmentOfPatients:"Appointment of patients",
  turnCounter: "Turn counter"
};
